import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@presentation/view/shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { AppMaterialModule } from 'src/app/app-material.module';
import { HomeComponent } from './home.component';
import { environment } from '@environment/environment';
import { HoraFormatadaPipe } from '@presentation/view/shared/pipes/horaFormatada.pipe';

@NgModule({
  declarations: [HomeComponent, HoraFormatadaPipe],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    AppMaterialModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaterialTimepickerModule.setOpts(environment.defaultLanguage, 'latn'),
    NgxMaskModule.forRoot(),
  ],
})
export class HomeModule {}
